import React from 'react';
import { syncNotifications, saveNotifications, exportNotifications, importNotifications, clearExportUrls, resetErrors } from '../../modules/notifications'
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import ItemsList from '../../components/ItemsList'
import ItemsListSkeleton from '../../components/ItemsListSkeleton'
import LoadingIndicator from '../../components/LoadingIndicator';
import EmptyView from '../../components/EmptyView';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OptionsMenu from '../../components/OptionsMenu';
import Link from '@mui/material/Link';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import ExportImportDialogs from '../../components/ExportImportDialogs';
import SolutionsArticleLink from '../../components/SolutionsArticleLink';
import API from '../../api/api';



class NewNotifications extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      notifications: [],
      showDownloadDialog: true,
      showImportCompleteDialog: false,
      errorLockCollapse: false,
      forceOpenExportDialog: false,
      forceOpenImportDialog: false
    }
  }

  componentDidMount() {
    this.props.syncNotifications(this.props.editLanguage)

    if(this.props.notifications.export_po_download_url || this.props.notifications.export_csv_download_url) {
      this.setState({showDownloadDialog: false})
    }
  }

  componentWillUnmount() {
    API.clearAllFetches();
  }

  componentWillReceiveProps(newProps) {
    const currentLanguage = this.props.editLanguage;
    const newLanguage = newProps.editLanguage;
    if(currentLanguage != newLanguage) {
      this.props.syncNotifications(newLanguage)
      return
    }

    if(this.props.notifications.import_notifications_pending === true && newProps.notifications.import_notifications_pending === false && !newProps.notifications.error && !newProps.notifications.import_cancelled) {
      this.setState({showImportCompleteDialog: true}, () => {
        this.setState({showImportCompleteDialog: false});
      })
    }

    if((this.props.notifications.sync_notifications_pending === true && newProps.notifications.sync_notifications_pending === false) || (this.props.notifications.save_notifications_pending === true && newProps.notifications.save_notifications_pending === false)) {
      const newNotifications = [];
      
      newProps.notifications.notifications.forEach(item => {
        if(item.source.title !== null && item.source.body_html !== null) {
          newNotifications.push({
            type: 'notification',
            id: item.id,
            progress: item.progress,
            title: item.source.title,
            info: '',
            fields: [{
              id: 'title',
              type: 'text',
              label: 'Title',
              source: item.source.title,
              target: item.target.title || ''
            },
            {
              multiline: true,
              rows: 20,
              id: 'body_html',
              type: 'text',
              label: 'Description',
              source: item.source.body_html || '',
              target: item.target.body_html || '',
            }]
          })          
        }
      })

      this.setState({notifications:newNotifications});
    }
  }

  onSave = items => {
    const usedItems = [];
    items.forEach(item => {
      usedItems.push({
        id: item.id,
        title: item.fields.find(x => x.id === 'title').target,
        body_html: item.fields.find(x => x.id === 'body_html').target,
      });
    })

    this.props.saveNotifications(this.props.editLanguage, usedItems)
  }

  onResaveAll = (itemId) => {
    const item = this.state.notifications.find(x => x.id == itemId);
    if(item) {
      const usedItems = [{
        id: item.id,
        title: item.fields.find(x => x.id === 'title').target,
        body_html: item.fields.find(x => x.id === 'body_html').target,
      }]

      this.props.saveNotifications(this.props.editLanguage, usedItems)
    }
  }

  onImport = (e) => {
    this.setState({forceOpenImportDialog: true}, () => {
      this.setState({forceOpenImportDialog: false});
    });   
    this.setState({ optionsMenuAnchorEl: null });
  }

  onExport = (e) => {
    this.setState({forceOpenExportDialog: true}, () => {
      this.setState({forceOpenExportDialog: false});
    });   
  }

  onCloseDownloadDialog = () => {
    this.setState({showDownloadDialog: false})
  }

  onCloseImportCompleteDialog = () => {
    window.location.reload();
  }

  render() {
    const { t } = this.props

    if(this.props.notifications.sync_notifications_pending === true || (this.props.notifications.error && this.props.notifications.error.level === 0)) {
      return <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          {t('pages.notifications.title')}
        </Typography>
        <Divider className="divider-white" />
        <ItemsListSkeleton rows="10"/>
        <LoadingIndicator
          pending={this.props.notifications.sync_notifications_pending || this.props.notifications.save_notifications_pending}
          progress={this.props.notifications.progress}
          error={this.props.notifications.error}
        />
      </React.Fragment>  
    }

    return <React.Fragment>
      <Typography variant="h4" gutterBottom component="h2">
        {t('pages.notifications.title')}

        <OptionsMenu
          onImport={this.onImport}
          onExport={this.onExport}
          shopPlan={this.props.shopPlan}
        />

        <SolutionsArticleLink
          article="notificationTranslations"
          subject={t('pages.notifications.title')}
          placement="headingMenu"
        />
      </Typography>
      <Divider className="divider-white" />
      <ItemsList 
        type="notifications"
        pagination={true}
        isPending={
          this.props.notifications.sync_notifications_pending ||
          this.props.notifications.save_notifications_pending ||
          this.props.notifications.export_notifications_pending ||
          this.props.notifications.import_notifications_pending
        }
        isSaving={
          this.props.notifications.save_notifications_pending
        }
        onSave={this.onSave}
        onResaveAll={this.onResaveAll}
        data={this.state.notifications}
        allowAutoTranslation={true}
        error={this.props.notifications.error}
        errorLockCollapse={this.state.errorLockCollapse}
        emptyMessage={
          <EmptyView 
            title={t('pages.notifications.noContent')}
            bottom={<Button href={`https://${this.props.shopUrl}/admin/settings/notifications`} target="_blank" variant="contained" color="primary">{t('system.createOneHere')}</Button>}
          />
        }
      />
      <LoadingIndicator
        pending={this.props.notifications.sync_notifications_pending || this.props.notifications.save_notifications_pending || this.props.notifications.export_notifications_pending || this.props.notifications.import_notifications_pending}
        loadingType={this.props.notifications.save_notifications_pending ? 'saving' : 'loading'}
        progress={this.props.notifications.progress}
        error={this.props.notifications.error}
        onErrorCancel={this.props.resetErrors}
        onErrorRetry={() => {
          this.setState({ errorLockCollapse: true }, () => {
            this.setState({ errorLockCollapse: false });
          });
        }}
      />

      <ExportImportDialogs
        //showDownloadDialog={this.state.showDownloadDialog}
        showImportCompleteDialog={this.state.showImportCompleteDialog}
        imported_entries={this.props.notifications.imported_entries}
        export_po_download_url={this.props.notifications.export_po_download_url}
        export_csv_download_url={this.props.notifications.export_csv_download_url}
        forceOpenExportDialog={this.state.forceOpenExportDialog}
        forceOpenImportDialog={this.state.forceOpenImportDialog}
        exportFunc={(options) => { this.props.exportNotifications(this.props.editLanguage, options) }}
        importFunc={(formData, fileType, options) => { this.props.importNotifications(formData, fileType, this.props.editLanguage) }}
        syncFunc={() => { this.props.syncNotifications(this.props.editLanguage)}}
        clearFunc={this.props.clearExportUrls}
        pending={this.props.notifications.export_notifications_pending}
        scope={'notifications'}
        additionalFields={['with_BOM']}
      />
    </React.Fragment> 
  }
}

const mapStateToProps = ({ shop, notifications }) => ({
  notifications: notifications,
  editLanguage: shop.shop.edit_language,
  shopPlan: shop.shop.charge.name,
  shopUrl: shop.shop.url,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      syncNotifications,
      saveNotifications,
      exportNotifications,
      importNotifications,
      resetErrors,
      clearExportUrls
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(NewNotifications)))